import { defineSagaForService } from '@repo/core'
import { checkUser } from '@repo/user-services'
import { checkUserActions } from '../../../slices'

export const checkUserMutationsServiceConfig = defineSagaForService({
  [checkUserActions.postRequest.type]: {
    apiClientDomain: 'user',
    service: checkUser,
    actionTypeResponse: checkUserActions.postResponse.type,
    actionTypeRequest: checkUserActions.postRequest.type,
  },
})
